import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { AppVersionCheckResponse } from '../../services/force-update/force-update.service';

@Component({
  selector: 'app-force-update-modal',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './force-update-modal.component.html',
  styleUrls: ['./force-update-modal.component.scss'],
})
export class ForceUpdateModalComponent implements OnInit {

  @Input() versionInfo: AppVersionCheckResponse;

  platform: string;
  storeUrl: string;

  ngOnInit() {
    this.platform = Capacitor.getPlatform();
    this.storeUrl =
      this.platform === 'ios'
        ? this.versionInfo?.updateUrl?.ios
        : this.versionInfo?.updateUrl?.android;
  }

  openStore() {
    if (this.storeUrl) {
      // '_system' routes through the OS to App Store / Play Store
      window.open(this.storeUrl, '_system');
    }
  }
}
